/** @format */

import { notificationActions } from 'src/config';
import BookingRequestAcceptedNotice from './booking-request-accepted';
import BookingRequestAssignedNotice from './booking-request-assigned';
import BookingRequestDismissNotice from './booking-request-dismiss';
import BookingRequestNewNotice from './booking-request-new';
import BookingRequestRejectedNotice from './booking-request-rejected';
import BookingRequestWaitingApprovalNotice from './booking-request-waiting-approval';
import BookingRequestRetractNotice from './booking-request-retract';
import BookingScheduleSetCarDriverNotice from './booking-schedule-set-car-driver';

const BookingRequestNotice = ({ pushAction, ...pushData }) => {
  switch (pushAction) {
    case notificationActions.BOOKING_REQUEST_ACCEPTED: {
      return <BookingRequestAcceptedNotice {...pushData} />;
    }
    case notificationActions.BOOKING_REQUEST_DISMISS: {
      return <BookingRequestDismissNotice {...pushData} />;
    }
    case notificationActions.BOOKING_REQUEST_WAITING_APPROVAL: {
      return <BookingRequestWaitingApprovalNotice {...pushData} />;
    }
    case notificationActions.BOOKING_REQUEST_ASSIGNED: {
      return <BookingRequestAssignedNotice {...pushData} />;
    }
    case notificationActions.BOOKING_REQUEST_REJECTED: {
      return <BookingRequestRejectedNotice {...pushData} />;
    }
    case notificationActions.BOOKING_REQUEST_RETRACT: {
      return <BookingRequestRetractNotice {...pushData} />;
    }
    case notificationActions.BOOKING_SCHEDULE_SET_CAR_DRIVER:
    case notificationActions.BOOKING_SCHEDULE_CHANGE_CAR_DRIVER: {
      return <BookingScheduleSetCarDriverNotice {...pushData} />;
    }

    default: {
      return <BookingRequestNewNotice {...pushData} />;
    }
  }
};

export default BookingRequestNotice;
